export default __webpack_public_path__ + "static/media/5.7e2a9821.jpg";